/**
 * Impersonation session state — read by the tenant tab to drive the banner.
 */

import { fetchAPI } from './client';

export interface ImpersonationWhoami {
  actor: { id: number; username: string; email: string };
  target: { id: number; username: string; email: string };
  reason_code: string;
  reason_note: string | null;
  started_at: string;
  ended_at: string | null;
}

export const impersonationAPI = {
  /** Returns null when no session is active (204 from backend). */
  async whoami(): Promise<ImpersonationWhoami | null> {
    const result = await fetchAPI<ImpersonationWhoami | undefined>(
      '/api/auth/impersonation/whoami',
    );
    return (result as ImpersonationWhoami) ?? null;
  },
  async exchange(code: string): Promise<void> {
    await fetchAPI('/api/auth/impersonation/exchange', {
      method: 'POST',
      body: JSON.stringify({ code }),
      // A rejected code (expired, already redeemed, malformed) answers 401.
      // That is a normal outcome of THIS call — exchange codes live 60s — and
      // the Impersonate page renders a proper explanation for it. Letting the
      // shared 401 handler fire instead wiped the admin's own session cache
      // and bounced the tab to the login screen, replacing a clear "could not
      // start impersonation, ask the admin to retry" with an unexplained
      // logout.
      suppressAuthRedirect: true,
    });
  },
  async end(): Promise<void> {
    await fetchAPI('/api/auth/impersonation/end', { method: 'POST' });
  },
};
